import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { FormConfigurationRouter } from './form-configuration.router';
import { reducers } from './state/form-configuration.selectors';


@NgModule({
  imports: [
    FormConfigurationRouter,
    StoreModule.forFeature('formConfiguration', reducers),
  ],
  declarations: []
})
export class FormConfigurationScreenModule { }